module.exports = __webpack_public_path__ + "static/media/bad-realm-skate-deck-pixelated.6ad493f6.png";